import { Map } from "immutable";
import { PaginatedData } from "@core/paginatedData";

export function idToItem<T extends { id: string }>(
	items: Map<string, T>,
	paginatedItems: PaginatedData<T> | null
): PaginatedData<T> | null {
	return paginatedItems
		? {
				...paginatedItems,
				content: paginatedItems.content.map(({ id }) => items.get(id)).filter((c): c is T => !!c),
			}
		: null;
}
